import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './title-text.scss.js';
import { getStyleClassNames } from '../../utilities/constants/styles.constants.js';

class TitleText extends s {
    constructor() {
        super(...arguments);
        this.isRtl = false;
        this.text = '';
        this.fontSize = 'Small';
        this.fontColor = 'Black';
        this.marginBottom = '0.5em';
        this.additionalClasses = '';
        this.textAlign = '';
    }
    render() {
        const containerClassNames = getStyleClassNames({
            marginBottom: this.marginBottom,
            additionalClasses: this.additionalClasses,
            isRtl: this.isRtl,
            textAlign: this.textAlign,
        });
        const titleClassNames = getStyleClassNames({
            fontSize: this.fontSize,
            fontColor: this.fontColor,
            isRtl: this.isRtl,
            additionalClasses: this.additionalClasses,
        });
        return $ `<div class="title-text ${containerClassNames}"><h2 class="${titleClassNames}"><slot></slot></h2></div>`;
    }
}
TitleText.styles = css_248z;
__decorate([
    e({ type: Boolean })
], TitleText.prototype, "isRtl", void 0);
__decorate([
    e({ type: String })
], TitleText.prototype, "text", void 0);
__decorate([
    e({ type: String })
], TitleText.prototype, "fontSize", void 0);
__decorate([
    e({ type: String })
], TitleText.prototype, "fontColor", void 0);
__decorate([
    e({ type: String })
], TitleText.prototype, "marginBottom", void 0);
__decorate([
    e({ type: String })
], TitleText.prototype, "additionalClasses", void 0);
__decorate([
    e({ type: String })
], TitleText.prototype, "textAlign", void 0);
customElements.define('title-text', TitleText);

export { TitleText };
